import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('auth', [
      'hasPermission',
      'hasAnyPermission',
      'hasRole',
      'userPermissions',
      'userRoles'
    ]),
  },
  methods: {
    /**
     * Check if user has a specific permission
     * @param {string} permission - Permission name to check
     * @returns {boolean}
     */
    checkPermission(permission) {
      return this.hasPermission(permission);
    },
    
    /**
     * Check if user has any of the specified permissions
     * @param {Array} permissions - Array of permission names
     * @returns {boolean}
     */
    checkAnyPermission(permissions) {
      return this.hasAnyPermission(permissions);
    },
    
    /**
     * Check if user has a specific role
     * @param {string} role - Role name to check
     * @returns {boolean}
     */
    checkRole(role) {
      return this.hasRole(role);
    },

    /**
     * Check if user is super admin or admin type
     * @returns {boolean}
     */
    isSuperAdmin() {
      return this.hasRole('super-admin') || this.isAdminType();
    },

    /**
     * Check if user type is admin
     * @returns {boolean}
     */
    isAdminType() {
      const currentUser = this.$store.getters['auth/currentUser'];
      return currentUser?.type === 'admin';
    },
  }
};

